<h1 mat-dialog-title class="pt-2 text-center"> Configuration des opérateurs</h1>
<div mat-dialog-content class="p-0">
    <div class="container no-gutters">
        <div class="row justify-content-center align-items-center">
            <div class="col-auto">Nb Opérateurs: {{Model.length}}</div>
            <button appPreventDoubleClick class="col-auto" color="primary" mat-mini-fab (throttledClick)="removeOperator()" [disabled]="!canRemove()">
                <mat-icon class="material-symbols-outlined">remove</mat-icon>
            </button>
            <button appPreventDoubleClick class="col-auto" color="primary" mat-mini-fab (throttledClick)="addOperator()" [disabled]="!canAdd()">
                <mat-icon class="material-symbols-outlined">add</mat-icon>
            </button>
        </div>
        <div class="row justify-content-center align-items-center">
            <div class="col-auto">Nb Cassettes: {{CassetteCount}}</div>
            <button appPreventDoubleClick class="col-auto" color="primary" mat-mini-fab (throttledClick)="removeCassette()" [disabled]="!canRemoveCassette()">
                <mat-icon class="material-symbols-outlined">remove</mat-icon>
            </button>
            <button appPreventDoubleClick class="col-auto" color="primary" mat-mini-fab (throttledClick)="addCassette()">
                <mat-icon class="material-symbols-outlined">add</mat-icon>
            </button>
        </div>
        @for (op of Model; track op; let i = $index) {
        <div>
            <div class="row m-0 ">
                <mat-form-field class="col-12">
                    <mat-label>Prénom</mat-label>
                    <input matInput [(ngModel)]="op.FirstName" placeholder="Prénom">
                </mat-form-field>
                <mat-form-field class="col-12">
                    <mat-label>Nom</mat-label>
                    <input matInput [(ngModel)]="op.LastName" placeholder="Nom">
                </mat-form-field>
            </div>
            @if (i < Model.length - 1) {
              <div class="my-3 mx-5" style="background: gray; height: 3px;">
        </div>
        }
    </div>
    }
    <div class="row m-1">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="primary" mat-raised-button (throttledClick)="finish()" [disabled]="!canFinish()">
            Ajouter
        </button>
    </div>
</div>
</div>